import { Box, Button } from '@mui/material';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginThunk } from '../redux/thunks/LoginThunk';
import { AccountCircle } from '@mui/icons-material';
import { CenteredPaper } from '../components/common/CenteredPaper';
import { RootState } from '../redux/rootReducer';

export const LoginPage = () => {
  const dispatch = useDispatch();

  const isPending = useSelector<RootState, boolean>(
    (store) => store.auth.pending,
  );

  const onLoginButtonClicked = useCallback(
    () => dispatch(loginThunk()),
    [dispatch],
  );

  return (
    <CenteredPaper icon={AccountCircle} title={'Connexion'}>
      Accédez à vos comptes en vous connectant avec Google.{' '}
      <em>
        L&apos;intégralité de vos données est stockée sur votre espace Google
        Drive personnel.
      </em>
      <br />
      <Button
        sx={{ marginTop: 4, width: '100%' }}
        color={'primary'}
        disabled={isPending}
        onClick={onLoginButtonClicked}
        variant={'contained'}
        size={'large'}
      >
        <Box
          component="img"
          alt={'Google logo'}
          sx={{ marginRight: 1, maxHeight: 24 }}
          src={'/assets/g-logo.png'}
        />
        Se connecter avec Google
      </Button>
    </CenteredPaper>
  );
};
